import React from 'react'

import Button from '../Button'
import Score from '../Score'

import share from 'lib/share'

import classes from './styles'

const Outcome = ({ outcome, reset }) => {

  const shareMessage = outcome.title

  return (
    <div className={classes.resultWrapper}>
      <Score />

      <div className={[classes.result, 'result'].join(' ')}>
        <h3>
          {outcome.title}
        </h3>
        <p>
          {outcome.text}
        </p>

        <div className={classes.buttonBlock}>
          <Button
            onClick={reset}
          >
            Еще раз
          </Button>
        </div>


        <div className={classes.sharedBlock}>
          <div className={classes.sharingTitle}>
            Рассказать друзьям:
          </div>

          <div>
            <img
              onClick={() => share.vk(shareMessage)}
              className={classes.share}
              src='https://10years.lifehacker.ru/static/images/vk_button.svg'
              alt=""
            />

            <img
              onClick={() => share.fb(shareMessage)}
              className={classes.share}
              src='https://10years.lifehacker.ru/static/images/fb_button.svg'
              alt=""
            />

            <img
              onClick={() => share.tw(shareMessage)}
              className={classes.share}
              src='https://10years.lifehacker.ru/static/images/tw_button.svg'
              alt=""
            />
          </div>
        </div>

      </div>
    </div>
  )
}


Outcome.propTypes = { }

export default Outcome
/*
import React from 'react'

const Outcome = ({ text }) => (
  <div>
    Game Over - {text}
  </div>
)

Outcome.propTypes = {
  text: React.PropTypes.string.isRequired,
}

export default Outcome

  */


// WEBPACK FOOTER //
// ./src/components/Outcome/Outcome.jsx